import { Component } from '@angular/core';
import { OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { config } from "../../../config/index";

@Component({
    template: require('./cart-success.component.html'),
    styles: [require('./cart-success.component.less')],
    preserveWhitespaces: true
})

export class CartSuccessComponent implements OnInit {
    role = config.role;
    constructor(
        private _router: Router
    ) { }
    ngOnInit() {
        setTimeout(() => {
            document
                .querySelector("body")
                .classList.add("body-not-found");
        });
    }

    ngOnDestroy() {
        document
            .querySelector("body")
            .classList.remove("body-not-found");
    }

    goHome() {
        window.location.replace(location.origin + config.publicPath + "/home/dashboard");
    }

}